import { MAP_SETUP_PATH } from '../../shared/navigation/constants';
export interface MobileState {
  isMobile: boolean;
  userEmail: string;
  continueTo: string;
};

export const initialMobileState: MobileState = {
  isMobile: false,
  userEmail: '',
  continueTo: MAP_SETUP_PATH
};
